import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// routes
import { CURD_L3_MENU_CHR } from "../../../../utils/routes";

// ---------------------------------------------------------------------

export const createL3MenuChr = createAsyncThunk(
  "l3MenuChr/createL3MenuChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(CURD_L3_MENU_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getL3MenuChr = createAsyncThunk(
  "l3MenuChr/getL3MenuChr",
  async (obj, {rejectWithValue}) => {
    try {
      const response = await axios.get(CURD_L3_MENU_CHR, { withCredentials: true });
      return response;
    } catch (err) {
      return rejectWithValue(err.response)
    }
  }
);

export const getL3MenuChrByL2Menu = createAsyncThunk(
  "l3MenuChr/getL3MenuChrByL2Menu",
  async (id) => {
    return axios.get(`${CURD_L3_MENU_CHR}/${id}`, { withCredentials: true });
  }
);

export const updateL3MenuChr = createAsyncThunk(
  "l3MenuChr/updateL3MenuChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(CURD_L3_MENU_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteL3MenuChr = createAsyncThunk(
  "l3MenuChr/deleteL3MenuChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(CURD_L3_MENU_CHR, {
        data,
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const l3MenuChrSlice = createSlice({
  name: "l3MenuChr",
  initialState: {
    loading: false,
    message: "",
    errMessage: "",
    l3MenuData: [],
    l3SelectedData: {},
  },
  reducers: {
    resetMessage: (state) => {
      state.message = "";
    },
    resetErrMessage: (state) => {
      state.errMessage = "";
    },
    rowSelect: (state, action) => {
      state.l3SelectedData = action?.payload.length > 0 && action?.payload[0];
    },
  },
  extraReducers: {
    [createL3MenuChr.pending]: (state, action) => {
      state.loading = true;
    },
    [createL3MenuChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [createL3MenuChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [getL3MenuChr.pending]: (state, action) => {
      state.loading = true;
    },
    [getL3MenuChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.l3MenuData = action?.payload?.data;
    },
    [getL3MenuChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    
    [getL3MenuChrByL2Menu.pending]: (state, action) => {
      state.loading = true;
    },
    [getL3MenuChrByL2Menu.fulfilled]: (state, action) => {
      state.loading = false;
      state.l3MenuData = action?.payload?.data;
    },
    [getL3MenuChrByL2Menu.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [updateL3MenuChr.pending]: (state, action) => {
      state.loading = true;
    },
    [updateL3MenuChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [updateL3MenuChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [deleteL3MenuChr.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteL3MenuChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [deleteL3MenuChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
  },
});

export const { resetMessage, resetErrMessage, rowSelect } =
  l3MenuChrSlice.actions;
export default l3MenuChrSlice.reducer;
